// extracted by mini-css-extract-plugin
export default {"checkboxRightLabel":"checkbox-right-label_checkboxRightLabel__Cxdjp"};